exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-mobile .card[data-v-52500972] {\n\tbackground-color: #ffffff !important;\n}\n", ""]);

// exports
